import { render, staticRenderFns } from "./PolizasSAMovimientos.vue?vue&type=template&id=d5009394&"
import script from "./PolizasSAMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasSAMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports